import { Directive, HostListener, Renderer2  } from '@angular/core';

import { ScrollService, PlatformService } from '@app/data';

@Directive({
  selector: '[appScroll]'
})
export class ScrollDirective {

  private scrollListener: any;
  private isBrowser = this.platform.isBrowser;

  constructor(
      private platform: PlatformService,
      private scroll: ScrollService,
      readonly renderer: Renderer2
  ) {
    if (this.isBrowser) {
      this._subscribeScroll();
    }
  }

  public subscribe = (): void => {
    this._subscribeScroll();
  }

  private _subscribeScroll = (): void => {
  // dynamically inserts a Listener for scroll
    if (! this.scrollListener) {

      this.scrollListener = this.renderer.listen(window, "scroll", (event) => {
        //console.log('ScrollDirective _subscribeScroll event ', event);

        // take over with animation frame in scroll service, then subscribe to Listener again
        this._unsubscribeScroll();
        this.scroll.watchScroll(this.subscribe);
      });
    }
  }

  private _unsubscribeScroll = (): void => {
  //remove Listener for scroll
    if (this.scrollListener) {this.scrollListener(); this.scrollListener = null;}
  }

}
